/* ============================================================
   PEAK MODE — Subscribe & Save Widget JS
   Loaded after theme.js on product pages.
   Hooks into existing #product-atc-btn flow.
   ============================================================ */
(function() {
  'use strict';

  var widget = document.getElementById('pm-sub');
  if (!widget) return; // No subscription plans for this product

  var options = widget.querySelectorAll('.pm-sub__option');
  var freqWrap = document.getElementById('pm-sub-freq-wrap');
  var freqSelect = document.getElementById('pm-sub-freq');
  var atcBtn = document.getElementById('product-atc-btn');
  var basePriceCents = parseInt(widget.dataset.basePriceCents, 10) || 0;

  // Money formatter — matches Shopify {{ money }} style ($X.XX)
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // Update displayed prices based on current base price
  function refreshPrices() {
    var onetimeDisplay = widget.querySelector('[data-price-display="onetime"]');
    var subDisplay = widget.querySelector('[data-price-display="sub"]');
    if (onetimeDisplay) onetimeDisplay.textContent = formatMoney(basePriceCents);
    if (subDisplay) subDisplay.textContent = formatMoney(Math.round(basePriceCents * 0.85));
  }

  // Toggle option active state + show/hide frequency
  function selectOption(option) {
    options.forEach(function(o) { o.classList.remove('pm-sub__option--active'); });
    option.classList.add('pm-sub__option--active');

    var radio = option.querySelector('.pm-sub__radio');
    if (radio) radio.checked = true;

    var planId = option.dataset.plan;
    if (planId && freqWrap) {
      freqWrap.hidden = false;
    } else if (freqWrap) {
      freqWrap.hidden = true;
    }
  }

  // Wire up clicks
  options.forEach(function(option) {
    option.addEventListener('click', function(e) {
      // Don't capture clicks on the frequency dropdown
      if (e.target.closest('.pm-sub__freq-select') || e.target.closest('.pm-sub__freq-wrap')) return;
      selectOption(option);
    });
  });

  // Override existing ATC behavior to include selling_plan
  if (atcBtn) {
    // Clone node to strip existing listeners from theme.js inline script
    var newAtc = atcBtn.cloneNode(true);
    atcBtn.parentNode.replaceChild(newAtc, atcBtn);
    atcBtn = newAtc;

    atcBtn.addEventListener('click', function() {
      var variantId = parseInt(atcBtn.dataset.variantId, 10);
      var qtyEl = document.getElementById('product-qty');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      if (!variantId || atcBtn.disabled) return;

      // Determine selling_plan from active option / frequency selector
      var activeOption = widget.querySelector('.pm-sub__option--active');
      var sellingPlanId = null;
      if (activeOption && activeOption.dataset.plan) {
        // If subscribe is active, use the freq dropdown's value
        sellingPlanId = freqSelect ? parseInt(freqSelect.value, 10) : parseInt(activeOption.dataset.plan, 10);
      }

      var payload = { id: variantId, quantity: qty };
      if (sellingPlanId) payload.selling_plan = sellingPlanId;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
      .then(function(r) { return r.json(); })
      .then(function(res) {
        if (res && res.status && res.status >= 400) throw new Error(res.description || 'Add to cart failed');
        atcBtn.textContent = '✓ Added!';
        document.dispatchEvent(new CustomEvent('cart:open'));
        return fetch('/cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count');
        countEls.forEach(function(el) { el.textContent = cart.item_count; });
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function(err) {
        console.error('ATC error:', err);
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
        alert('Sorry, something went wrong adding to cart. Please try again.');
      });
    });
  }

  // Expose price refresh so variant-change code (if any) can call it.
  // Future hook: if variant changes update basePriceCents from variant data.
  window.PMSubWidget = {
    setBasePrice: function(cents) {
      basePriceCents = cents;
      widget.dataset.basePriceCents = cents;
      refreshPrices();
    }
  };

  // Init
  refreshPrices();
})();